import React, { forwardRef } from "react";

import { StyledTiles } from "./Styles";
import { Breakpoint } from "../BreakPoints";
import { Space } from "../LayoutTokens";

export interface ITilesProps extends React.ComponentPropsWithoutRef<"div"> {
  columns: number;
  space?: Space;
  collapseBelow?: Breakpoint;
}

export const Tiles = forwardRef<HTMLDivElement, ITilesProps>(
  ({ columns, space = "md", collapseBelow, children, ...rest }, ref) => (
    <StyledTiles
      ref={ref}
      $cols={columns}
      $space={space}
      $collapse={collapseBelow}
      {...rest}
    >
      {children}
    </StyledTiles>
  )
);

Tiles.displayName = "Tiles";
